import { render, staticRenderFns } from "./ProjectPool.vue?vue&type=template&id=af97f7d4&"
import script from "./ProjectPool.vue?vue&type=script&lang=js&"
export * from "./ProjectPool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports